module.exports = __webpack_public_path__ + "static/media/icon_view_bottom.0e549770.svg";